import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'E',
      name: i18n.t('tipos.residencia.e')
    },
    {
      id: 'R',
      name: i18n.t('tipos.residencia.r')
    },
    {
      id: 'U',
      name: i18n.t('tipos.residencia.u')
    },
  ]
}

export function TIPOS_RESIDENCIA (state) {
  return configHelper.getConfig(state, 'TIPOS_RESIDENCIA', GenerateConfig)
}
